import { List } from '@zillow/constellation-10';

const WizardTipContent = () => {
  return (
    <div data-testid="WizardTipContent">
      <List.Root css={{ paddingLeft: '600' }}>
        <List.Item> We&apos;ll deliver renter inquiries to the email you provide here.</List.Item>
        <List.Item>Other communications from Zillow will be sent to your account email.</List.Item>
      </List.Root>
    </div>
  );
};

export default WizardTipContent;
